module.exports = __webpack_public_path__ + "static/media/ribbonBall.63e95c49.svg";